export const T = {
  en_GB: {
    riskAssessmentNotConfigured: "Risk assessment not configured for this flow.",
    saveFailed: "Failed to save your answer. Please try again.",
    riskAnswerNotSaved:
      "This combination of answers can't be saved. Please choose a different option or contact your advisor.",
  },
  nb_NO: {
    riskAssessmentNotConfigured: "Risikovurdering er ikke konfigurert for denne flyten.",
    saveFailed: "Kunne ikke lagre svaret ditt. Vennligst prøv igjen.",
    riskAnswerNotSaved:
      "Denne kombinasjonen av svar kan ikke lagres. Velg et annet alternativ eller kontakt rådgiveren din.",
  },
} as const;
